import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import logo from '../../assets/images/navbar_logo.png';
import axios from 'axios';
import { useDispatch } from "react-redux";
import { setDataWebpage } from '../../store/data/dataSlice';
import { API_KEY } from '../../constants';

export function Menu({ props }) {
    const dispatch = useDispatch();
    const [data,setData] = React.useState()

    React.useEffect(()=> {
        let sheet2 = "WEBPAGE"
        axios.get(`https://sheets.googleapis.com/v4/spreadsheets/1FyBkFmdLO8BeNdmDohYRvAh_nJP1jsdsEZ_rPYm8m1s/values/${sheet2}?key=${API_KEY}`)
        .then(res => {
            const data = res.data.values;
            setData(data)
            dispatch(setDataWebpage(data));
            console.log(`https://drive.google.com/uc?id=${data[2][1].split('/')[5]}`)
        });
    },[])
    if(data){
        return (
            <header className="header-container">
            <div className="header-top-bar"></div>
            <nav className="header-nav">
            <a href="/" className="header-logo">
            <img
                src={data? `https://drive.google.com/thumbnail?id=${data[2][1].split('/')[5]}&sz=w400` : logo}
                className="d-inline-block align-top"
                alt="Yo desarrollo"
                style={{ maxHeight: 40 }}
            />
            </a>
            <div className="header-nav-links">
            </div>
            {/* <a href="/" className="header-cta-button">Agendar Cita</a> */}
            {/* <button className="header-mobile-menu">
                <i className="fas fa-bars"></i>
            </button> */}
            </nav>
        </header>
        )
    }else{
        return (
            <div>
                <h1>Cargando...</h1>
            </div>
        )
    }
}